export enum RouteCoachName {
  ACCUEIL_CONNECTEE = 'agir',
  SERVICES_LINKY = 'services-linky',
  BIBLIOTHEQUE = 'bibliotheque',
}
